let _ = require("ES/lib/lodash");
let esUtils = require("ES/utils/esUtils");
let Constants = require("../../../../../utils/Constants");
let FormUtils = require("../../../../../utils/FormUtils");
let createStandardEventForm = require("../../createStandardEventForm");
let ezHorizontalFields = require("react-loose-forms.bootstrap3/layouts/ezHorizontalFields");
let dd = require("ES/lib/dd");

module.exports = createStandardEventForm({
    eventToInitialValues(event){
        return {
            ccNotes: event.ccNotes,
            ccDateTime: event.ccDateTime,
            ccTimezone: event.ccTimezone,
            ccInitiator: esUtils.toInt(event.ccInitiator) || null
        };
    },
    buildSchema({Displaylists}){
        return {
            ccDateTime: {
                label: "When",
                type: "date",
                pick_time: true,
                validate: FormUtils.v.optional
            },
            ccTimezone: {
                label: "Time Zone",
                type: "select",
                placeholder: "-- local time --",
                options: _.object(_.map(Displaylists && Displaylists.universal && Displaylists.universal.timezones, function (timezone) {
                    return [timezone, timezone];
                })),
                dont_sort_options: true,
                validate: FormUtils.v.optional
            },
            ccInitiator: {
                label: "Call Initiated By",
                type: "select",
                options: _.object(_.map(Constants.CC_INIT_VALUES, function (name, id) {
                    return [id, name];
                })),
                validate: FormUtils.v.optional
            },
            ccNotes: {
                label: "Notes",
                type: "textarea"
            }
        };
    },
    renderFields(){
        let self = this;
        return dd.div(null,
            ezHorizontalFields(this, [
                ["ccDateTime"],
                ["ccTimezone"],
                ["ccInitiator"],
                ["ccNotes"]
            ]),
            dd.div({className: "pull-right", style: {marginRight: "1em"}},
                dd.a({
                        onClick: function () {
                            self.setState({
                                data: {
                                    ccTimezone: null,
                                    ccDateTime: null,
                                    ccInitiator: null,
                                    ccNotes: null
                                }
                            });
                        }
                    },
                    'clear'
                )
            )
        );
    },
    writeInputDataToEvent(data, event){
        event.ccNotes = data.ccNotes;
        event.ccDateTime = _.isDate(data.ccDateTime) ? data.ccDateTime : null;
        event.ccTimezone = data.ccTimezone;
        event.ccInitiator = esUtils.toInt(data.ccInitiator);
    }
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/contacts/ClientCall.js